import type { EmployeeViewModelWithName } from '../../types';
import type { FunctionViewModel } from '@trinnvis/dabih-api-client';
import { toGroupedEmployees } from './to-grouped-employees';
import type { FeatureStates } from '../featureStates';
import type { ListSectionItemInput } from '../../../library/lists/listSectionItemInput';

export function employeeGroupsAsListItems(
  hrefPrefix: string,
  employees: EmployeeViewModelWithName[],
  functions: FunctionViewModel[],
  featureStates: FeatureStates,
): ListSectionItemInput[] {
  const groupKeyValue: (e: EmployeeViewModelWithName) => string =
    featureStates.core || featureStates.hse
      ? (e) => (e.associationType ? e.associationType : 'Tilknytning ikke angitt')
      : (e) => {
          switch (e.accessLevel) {
            case 'NONE':
              return 'Ingen tilgang';
            case 'READONLY':
              return 'Begrenset tilgang';
            case 'USER':
              return 'Full tilgang';
            case 'ASSETS':
              return 'Utstyrstilgang';
            default:
              return 'Ingen tilgang';
          }
        };
  const employeeGroups = toGroupedEmployees(hrefPrefix, employees, functions, groupKeyValue);
  return employeeGroups.map((group) => {
    const result: ListSectionItemInput = {
      label: group.employeeGroupName,
      accessible: false,
      items: group.employees.map((employee) => ({
        label: employee.name,
        labelItems: featureStates.core || featureStates.hse ? employee.functions : [],
        href: employee.href,
        accessible: true,
        hasDraft: employee.hasDraft,
      })),
    };
    if (group.terminated) {
      result.sublistToggle = true;
      result.sublistHidden = true;
    }
    return result;
  });
}
